import React from 'react';

type Props = { 
  title: string,
  children: React.ReactNode, 
};

function MainPageTemplateColumnLayout(props: Props) {

  return (
    <div className="main" style={{ marginLeft: '0px', marginRight: '0px' }}>
      <div className="box-container">
        <div className="header">{props.title}</div>
        <div className="box-column">
          {props.children}
        </div>
      </div>
    </div>
  );  

}

export default MainPageTemplateColumnLayout;




